import { resolveMediaUrl } from './media'

/** 将开包/合成等 API 卡牌列表归并为展示项（同名卡牌合并数量） */
export function normalizeRewardItems(raw) {
  if (!raw) return []
  const list = Array.isArray(raw) ? raw : [raw]
  const map = new Map()
  for (const c of list) {
    if (!c || typeof c !== 'object') continue
    const id = c.cardId ?? c.card_id ?? c.cardName ?? c.name ?? Math.random()
    const img = resolveMediaUrl(c.cardImg ?? c.card_img ?? c.image ?? '')
    const name = c.cardName ?? c.name ?? '未知卡牌'
    if (map.has(id)) {
      map.get(id).count += 1
    } else {
      map.set(id, {
        cardId: c.cardId ?? c.card_id,
        cardName: name,
        cardImg: img,
        count: 1,
        rarity: c.rarity,
      })
    }
  }
  return Array.from(map.values())
}

/** 合成结果 → reward-result-modal 展示项（卡牌/积分/余额/失败） */
export function normalizeComposeResult(data) {
  if (!data || typeof data !== 'object') {
    return [{ cardName: '合成失败', cardImg: '', count: 1 }]
  }
  const failed =
    data.success === false ||
    data.resultType === 'failure' ||
    data.rewardType === 'failure'
  if (failed) {
    return [{ cardName: '合成失败', cardImg: '', count: 1 }]
  }
  if (data.cardId != null || data.cardName || data.cardImg) {
    return normalizeRewardItems([data])
  }
  if (data.points != null && data.points !== '') {
    return [{ cardName: `积分 ${data.points}`, cardImg: '', count: 1 }]
  }
  if (data.balance != null && data.balance !== '') {
    return [{ cardName: `余额 ${data.balance} 元`, cardImg: '', count: 1 }]
  }
  return [{ cardName: '奖励', cardImg: '', count: 1 }]
}

/** 单条分解结果 → reward-result-modal 展示项 */
export function normalizeDecomposeResult(data) {
  if (!data || typeof data !== 'object') return []
  if (data.cardId != null || data.cardName || data.cardImg) {
    return normalizeRewardItems([data])
  }
  if (data.points != null && data.points !== '') {
    return [{ cardName: `积分 ${data.points}`, cardImg: '', count: 1 }]
  }
  if (data.balance != null && data.balance !== '') {
    return [{ cardName: `余额 ${data.balance} 元`, cardImg: '', count: 1 }]
  }
  const legacy = data.rewards
  if (Array.isArray(legacy)) {
    const items = []
    for (const r of legacy) {
      const t = r.type || r.rewardType
      if (t === 'card' && (r.cardId || r.cardName)) {
        items.push(...normalizeRewardItems([r]))
      } else if (t === 'points') {
        items.push({ cardName: `积分 ${r.value ?? r.points ?? 0}`, cardImg: '', count: 1 })
      } else if (t === 'balance') {
        items.push({ cardName: `余额 ${r.value ?? r.balance ?? 0} 元`, cardImg: '', count: 1 })
      }
    }
    return items
  }
  return [{ cardName: '奖励', cardImg: '', count: 1 }]
}

/** 批量分解结果合并展示 */
export function mergeDecomposeResults(resultList) {
  const map = new Map()
  for (const data of resultList || []) {
    for (const item of normalizeDecomposeResult(data)) {
      const key = item.cardId != null ? `card-${item.cardId}` : item.cardName
      if (map.has(key)) {
        map.get(key).count += item.count || 1
      } else {
        map.set(key, { ...item, count: item.count || 1 })
      }
    }
  }
  return Array.from(map.values())
}

/** 幸运掉落 → reward-result-modal 展示项 */
export function normalizeLuckyDropItems(raw) {
  if (!raw) return []
  const list = Array.isArray(raw) ? raw : [raw]
  const items = []
  for (const row of list) {
    if (!row || typeof row !== 'object') continue
    const rewardType = row.rewardType || row.reward_type
    if (rewardType === 'card' && (row.cardId != null || row.cardName || row.cardImg)) {
      items.push(...normalizeRewardItems([row]))
      continue
    }
    if (rewardType === 'points' || row.points != null) {
      const pts = row.points != null ? row.points : row.rewardValue
      items.push({ cardName: `积分 ${pts}`, cardImg: '', count: 1 })
      continue
    }
    if (rewardType === 'balance' || row.balance != null) {
      const bal = row.balance != null ? row.balance : row.rewardValue
      items.push({ cardName: `余额 ${bal} 元`, cardImg: '', count: 1 })
      continue
    }
    const name = row.dropName || row.drop_name || '成交礼遇'
    items.push({ cardName: name, cardImg: row.cardImg || '', count: 1 })
  }
  return items
}
